var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TabsSlider',{attrs:{"selectedTab":_vm.selectedTab,"tabs":_vm.tabs,"hide-empty":_vm.hideEmpty,"variant":"underline"},on:{"update:selectedTab":_vm.onUpdateSelectedTab}})
}
var staticRenderFns = []

export { render, staticRenderFns }